import React from 'react'
import {Field, formValueSelector, getFormValues} from 'redux-form'
/*svj21 start */
import { SVCPOInputEp, SVPNInputEp, SVPCInputEp} from '../core'
//import { SVPCInputEp, SVPNInputEp} from '../core'
/*svj21 end */
const svinput = ({input, label, type, meta:{error, touched}})=>{
    return(

     
            <input {...input}  component="input" type="input" placeholder="clubName"  className="form-control" />
           

    
       
    )

}
 export class SVCDeviceComponentEp extends React.Component{
    

    constructor(props){
        super(props)
       
        this.svfieldType=  this.props.portType || 'CL_String'
        this.state={
            svfieldType: this.props.portType || 'CL_String'
        }
        


    }
    componentWillReceiveProps(next){
        console.log(next)

    }

    
    render(){
        let me = this
        console.log(this.props)
        const {member, index, deviceTypes}= this.props
          /*svj21 start*/
          const {isdcodeTypes} = this.props
          console.log("*******svj2****ADevice** START")
          console.log(isdcodeTypes)

          console.log("*******svj2****ADevice** END")

            /*svj21 end*/
        return ( 
            <div className="box-block">  
                <div className="form-group">
                            <label htmlFor={`${member}.deviceType`}  > Device Type <span class="svr-required">*</span></label>
                            <Field  component="select" id={`${member}.deviceType`}   name={`${member}.deviceType`} className="form-control" >
                                <option value="">Select Device Type</option>
                                {

                                    deviceTypes.map(  (o, idx)=>(  <option value={o.value} key={o.name}>{o.name}</option>)
                                        
                            
                            )}
                    
                            </Field>
                </div>
                <div className="form-group">
                        <label className="svform-label" htmlFor="`${member}.countryCallingCode`" > Country Calling Code <span class="svr-required">*</span></label>
                        <SVCPOInputEp member={member} index={index} isdcodeTypes={isdcodeTypes} placeholder="34" /> 
                          
                         {/* 
                         <SVPCInputEp member={member} index={index} placeholder="34" /> 
                        
                          
                        */}
                   
                       
                 </div>  
                 <div className="form-group">
                        <label className="svform-label" htmlFor="`${member}.number`" > Device Number <span class="svr-required">*</span></label>
                        <SVPNInputEp member={member} index={index} placeholder="Madrid" /> 
                        
                    </div>  
                
            </div>    
         )


    }
}

